module.exports = require("././angular-resource.js");


//////////////////
// WEBPACK FOOTER
// angular-resource (bower component)
// module id = 20
// module chunks = 0